import * as yup from "yup";
import { parseCurrencyString } from "@/utils/parseCurrencyString";

export const cashWithdrawalSchema = yup.object({
  amount: yup
    .string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Valor é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Valor deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),
});

export const changeSchema = yup.object({
  change_amount: yup
    .string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Valor é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Valor deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),
});
